import { render, staticRenderFns } from "./PainelProcessosRiscos.vue?vue&type=template&id=9be08126"
import script from "./PainelProcessosRiscos.vue?vue&type=script&lang=js"
export * from "./PainelProcessosRiscos.vue?vue&type=script&lang=js"
import style0 from "./PainelProcessosRiscos.vue?vue&type=style&index=0&id=9be08126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports